import { render, staticRenderFns } from "./SendPasswordModal.vue?vue&type=template&id=0519eea6"
import script from "./SendPasswordModal.vue?vue&type=script&lang=ts"
export * from "./SendPasswordModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports